import React from 'react';
import ConfigProductBrowser from '../ConfigProductBrowser';
import { Modal } from '../../components';

export const AddConfigProductModal = (props) => {
    const { show, onClose, projectId, tag, saveHandler } = props;

    return (
        <Modal
            fitContent
            show={show}
        >
            <div className="bg-black-5">
                <div className="divide-y-2 divide-solid">
                    <div className="sm:container pl-4 pr-4 pt-4">
                        <h1>Configured Product Catalog</h1>
                        <ConfigProductBrowser
                            show={show}
                            tag={tag}
                            projectId={projectId}
                            saveHandler={saveHandler}
                            onClose={onClose}
                        />
                    </div>
                    <div className="flex justify-end p-4">
                        <button
                            onClick={onClose}
                            type="button"
                            className="swegon-like-button contained"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
